"use strict";
exports.__esModule = true;
exports.routes = void 0;
exports.routes = {
    referral: {
        initiate: '/referral/initiate',
        list: '/referrals/list'
    },
    serviceDelivery: {
        list: '/track-services/list-tracked-sessions',
        track: '/track-services/track-session'
    }
};
//# sourceMappingURL=routes.js.map